/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type ArchetypeKey =
  | 'visionary_strategist'
  | 'bold_initiator'
  | 'encouraging_connector'
  | 'steady_builder'
  | 'reflective_guide'
  | 'curious_explorer';

/**
 * Shared archetype icon component. Renders Steve's designer PNG icons
 * (178x178, green-background-and-line-art-baked-in) at the requested size.
 * Same assets used in the archetype-wheel — extracted here so other surfaces
 * (Six IPSAT Archetypes cards, dashboard cards, etc.) stay visually
 * consistent with the wheel.
 *
 * Usage:
 *   <app-archetype-icon archetype="visionary_strategist" size="40">
 *   </app-archetype-icon>
 */
const ICON_FILES: Record<ArchetypeKey, string> = {
  visionary_strategist: 'visionary-strategist.png',
  bold_initiator: 'bold-initiator.png',
  encouraging_connector: 'encouraging-connector.png',
  steady_builder: 'steady-builder.png',
  reflective_guide: 'reflective-guide.png',
  curious_explorer: 'curious-explorer.png',
};

@Component({
  selector: 'app-archetype-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      [src]="'assets/images/archetype/' + iconFile"
      [attr.width]="size"
      [attr.height]="size"
      [attr.alt]="archetype"
      style="display: block;"
    />
  `,
  styles: [`
    :host { display: inline-flex; vertical-align: middle; line-height: 0; }
  `]
})
export class ArchetypeIconComponent {
  @Input() archetype!: ArchetypeKey;
  @Input() size: number | string = 40;

  get iconFile(): string {
    return ICON_FILES[this.archetype] || ICON_FILES.visionary_strategist;
  }
}
